import { Injectable, signal } from '@angular/core';
import { ApiManufacturer } from 'api';
import { User } from 'auth/user.interface';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  public manufacturer = signal<ApiManufacturer | null>(null);

  public user = signal<User | null>(null);
  public adminTenantId = signal<string | null>(null);
}
